<template>
  <div class="w-100">
    <TreeSelect
      v-bind="$attrs"
      v-model="costCenterId"
      v-model:modal-visible="selectModalVisibility"
      :entity-name="t('global.board')"
      :multiple="selectionMode === 'multiple'"
      :elements="result?.SQDCBoards ?? []"
      :show-inline-create="false"
      :valid="valid"
      :loading="loading"
      :hide-path="true"
      :disabled="disabled"
      :disabled-nodes="disabledNodes ?? []"
      :clearable="clearable"
      :auto-select-first="autoSelectFirst"
      :inline="inline"
    />
  </div>
</template>

<script setup lang="ts">
import { useTranslation } from "@/language/translation";

import { computed, ref, type PropType } from "vue";
import { useSQDCBoardsForSelectQuery } from "@/graphql";
import TreeSelect from "@/components/shared/searchSelect/treeSelect/TreeSelect.vue";
const { t } = useTranslation();

const props = defineProps({
  variables: {
    type: Object as PropType<
      Partial<{
        ids: number[] | number;
        siteIds: number[] | number;
        onlySiteWithPermission: boolean;
      }>
    >,
    required: false,
    default: () => ({}),
  },
  selectionMode: {
    type: String as PropType<"single" | "multiple">,
    required: false,
    default: "single",
  },
  autoSelectFirst: {
    type: Boolean,
    required: false,
    default: false,
  },
  valid: {
    type: Boolean,
    required: false,
    default: undefined,
  },
  clearable: {
    type: Boolean,
    required: false,
    default: true,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  disabledNodes: {
    type: Array as PropType<
      {
        key: string | number;
        includeChildren: boolean;
      }[]
    >,
    required: false,
    default: undefined,
  },
  inline: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const { result, loading } = useSQDCBoardsForSelectQuery(computed(() => props.variables));

const costCenterId = defineModel("modelValue", {
  type: [Array, Number] as PropType<number | number[] | undefined>,
  default: undefined,
});

const selectModalVisibility = ref(false);
</script>

<style lang="scss" scoped></style>
